import { X } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Info, Section } from "../Common/CardUIHelpers";
import { ProductOrder } from "../../../types/admin/productOrder.types";

export function OrderCard({
  order,
  onClose,
}: {
  order: ProductOrder;
  onClose: () => void;
}) {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />

      <div className="relative mt-5 w-full max-w-5xl bg-popupLight dark:bg-popupDark rounded-2xl shadow-xl p-8">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-2 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700"
        >
          <X size={20} />
        </button>

        <h2 className="text-2xl font-bold mb-6">
          {t("Product Order Details")}
        </h2>

        <Section title={t("Customer")}>
          <Info label={t("Name")} value={order.user?.name} />
          <Info label={t("Phone")} value={order.user?.phone} />
          <Info label={t("Email")} value={order.user?.email} />
        </Section>

        <Section title={t("Product Details")}>
          <Info label={t("Name")} value={order.product?.name} />
          <Info label={t("Description")} value={order.product?.description} />
          <Info label={t("Price")} value={`₹${order.product?.price}`} />
        </Section>

        <Section title={t("Other Details")}>
          <Info label={t("Quantity")} value={order.quantity} />
          <Info label={t("Ordered At")} value={order.createdAt.split("T")[0]} />
          <Info
            label={t("Expected Delivery")}
            value={order.expectedDelivery.split("T")[0]}
          />
          <Info label={t("Total Price")} value={`₹${order.price}`} />
        </Section>
      </div>
    </div>
  );
}
